<script lang="ts">
  import { onMount } from 'svelte';
  import { renderMarkdown, type ParsedMarkdown } from '../../lib/markdown';
  import { withPageTitle } from '../../lib/page-title';
  import EmptyState from '../../components/ui/EmptyState.svelte';

  // Static legal/info page. The slug picks one of the bundled markdown
  // sources in src/content/legal — invalid slugs render the 404-style
  // empty state rather than throwing, so a typo'd link doesn't crash
  // the SPA.

  interface Props {
    slug: string;
  }

  let { slug }: Props = $props();

  let parsed = $derived<ParsedMarkdown | null>(renderMarkdown(slug));

  $effect(() => {
    if (!parsed?.title) return;
    return withPageTitle(parsed.title);
  });

  // Open external links in a new tab, leave internal links alone so
  // svelte-routing's Link interception still works.
  onMount(() => {
    const root = document.querySelector('.markdown-page__body');
    if (!root) return;
    for (const a of root.querySelectorAll<HTMLAnchorElement>('a[href^="http"]')) {
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
    }
  });
</script>

{#if parsed}
  <article class="markdown-page">
    {#if parsed.title}
      <h1 class="markdown-page__title">{parsed.title}</h1>
    {/if}
    <div class="markdown-page__body">{@html parsed.html}</div>
  </article>
{:else}
  <EmptyState
    title="Page not found"
    body="The page you're looking for doesn't exist."
  />
{/if}
